interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteConfirmModal({ onConfirm, onCancel }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-lg w-full max-w-sm p-6 text-center">
        <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-4">
          <i className="ri-delete-bin-line text-red-500 text-xl"></i>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">Delete Listing?</h3>
        <p className="text-gray-500 text-sm mb-6">This will permanently remove this listing. This action cannot be undone.</p>
        <div className="flex items-center gap-3 justify-center">
          <button
            onClick={onCancel}
            className="px-5 py-2 rounded-md text-sm text-gray-600 hover:bg-gray-100 cursor-pointer transition-colors whitespace-nowrap"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md text-sm font-semibold cursor-pointer transition-colors whitespace-nowrap"
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
}
